<template>
  <v-container >
    <v-snackbar
      v-model="snackbar"
      :timeout="8000"
      top
      color="orange" dark
    >
      {{text}}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-row justify="center" class="mt-12">
      <v-col cols="12" xl="4" lg="4" md="5" sm="6" xs="12">
        <v-card class="elevation-0" >
          <v-card-text class="mt-2 pb-0">
            <v-img :src="logo"  height="200" contain />
            <v-form>
              <!-- EMAIL -->
              <v-text-field
                dense
                autofocus
                v-model="email" 
                prepend-icon="email" 
                label="Correo" 
                required
                type="text">
              </v-text-field>

              <!-- PASSWORD -->
              <v-text-field
                dense
                v-model="password"
                prepend-icon="lock"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                label="contraseña"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
              ></v-text-field>

              <v-col xs12>
                <v-card v-if="error" color="red lighten-1" class=" px-2 py-2">
                  <div class="white--text">
                    {{ error }}
                  </div>
                </v-card>
              </v-col>

            </v-form>
          </v-card-text>
            
              <!-- BOTONES -->
          <v-card-actions class="mt-0 mx-3">
            <v-btn  color="secondary"  small dark :to="{name:'registrarse'}" class="elevation-5">Registrate</v-btn>

            <v-spacer></v-spacer>

            <v-btn  color="primary"  small dark @click="ingresar" class="elevation-5">Login</v-btn>
          </v-card-actions>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  
              color="primary darken-3" dark small 
              :to="{name: 'olvidacontra'}">Olvide mi contraseña.
            </v-btn>
          </v-card-actions>
            
          

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/router'
import {mapActions , mapGetters} from 'vuex'
  export default {
    data(){
      return{
        logo:'',


        password: '',
        email:'',

        snackbar: false,
        y: 'top',
        x: null,
        mode: '',
        timeout: 8000,
        text: '',

        show1: false,
        error: '',


        rules: {
          required: value => !!value || 'Requerido.',
          min: v => v.length >= 8 || 'Minimo 8 caracteres',
          emailMatch: () => ('El correo y/o la contraseña no son correctos')
        },

        NombreAsig: '',
        Nomuser: '',
      }
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario']),
    },

    created(){
      this.getLogo()
    },

    
    methods:{
      ...mapActions('login',['validarUser']),
      ...mapActions('login',['GetInfoUser']),

      getLogo(){
        this.$http.get('config.list').then(response=>{
          var ciaws = response.body
          this.logo = this.$http.options.root + 'fotos/' + ciaws.logourl
        }, error => {
          console.log(error)
        })
      },


      ingresar (){
        var md5     = require('md5')
        // var payload = { "Username": this.email, "Password": md5(this.password)}
        var usuario = { "email"   : this.email, "password": md5(this.password)}
        // Traemos la información del usuario
        this.GetInfoUser(usuario).then(response => {
          if(response == false){
            this.text  = "Verifica que tus datos esten correctos"
            this.snackbar = true 
            return
          }else if(response == true){
            this.$router.push({ name: 'home' })  
          }else{
            this.text  = response
            this.snackbar = true 
          }
        }).catch(error =>{
          console.log(error)
        })
      }
    }
  };


</script>

<style scoped>
  
  .logo{
    align-content: "center";
    text-align: center;

  }
</style>


  